import React from 'react';
import { TextInput } from './TextInput';

export const DateOfBirthInput = ({ onChange }) => {
  const [month, setMonth] = React.useState('');
  const [day, setDay] = React.useState('');
  const [year, setYear] = React.useState('');

  const dayRef = React.useRef();
  const yearRef = React.useRef();

  React.useEffect(() => {
    onChange(month || day || year ? `${month}/${day}/${year}` : '');
    // Adding onChange to deps array causes Maximum depth exceeded errors. The parent component needs to be refactored to not create new functions on every render
  }, [month, day, year]);

  React.useEffect(() => {
    if (month.length == 2) {
      dayRef.current.focus();
    }
  }, [month]);

  React.useEffect(() => {
    if (day.length == 2) {
      yearRef.current.focus();
    }
  }, [day]);

  return (
    <>
      <TextInput
        value={month}
        onChange={(value) => setMonth(value)}
        autoFocus={true}
        placeholder="mm"
        inputMode="numeric"
        maxLength={2}
      />
      <TextInput
        ref={dayRef}
        value={day}
        onChange={setDay}
        placeholder="dd"
        inputMode="numeric"
        maxLength={2}
      />
      <TextInput
        ref={yearRef}
        value={year}
        onChange={setYear}
        placeholder="yyyy"
        inputMode="numeric"
        maxLength={4}
      />
    </>
  );
};
